<template>
    <div class="edit-favorite-item">
        <form class="edit-favorite-item__form" @submit.prevent="sendData">
            <input v-if="staticHiddenData" v-for="(hiddenFieldValue, name)  in staticHiddenData" type="hidden" :name="name" :value="hiddenFieldValue">
            <input type="text"
                   name="name"
                   :value="value"
                   class="def-input"
                   ref="name"
                   :placeholder="message.placeholderGroup"
            >

            <button type="submit" v-if="screenWidth >= 992">{{ message.btnSave }}</button>
<!--            <span v-if="screenWidth < 992" @click="closeBlock">{{ message.btnCancel }}</span>-->
            <div class="edit-favorite-item__form-group">
                <span v-if="screenWidth >= 992" @click="closeBlock">{{ message.btnCancel }}</span>
                <label>
                    <input type="checkbox" name="changeBase">
                    <span class="label-input"></span>
                    <span>{{ message.checkboxAddMain }}</span>
                </label>
            </div>
            <div class="edit-favorite-item__form-group" v-if="screenWidth < 992">
                <button type="submit" >{{ message.btnSave }}</button>
                <span @click="closeBlock">{{ message.btnCancel }}</span>
            </div>
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "edit-favorite-item",
    props: {
        route: {
            type: Object,
        },
        value: {
            type: String,
        },
        addFavorite: {
            type: Boolean,
        },
        groupId: {
            type: [String, Number],
        }
    },
    data(){
        return{
            close: false,
        }
    },
    methods: {
        closeBlock() {
            this.$emit('showEditSettings', this.close)
        },
        sendData({ target }) {
            if ( this.addFavorite ) {
                this.addFavoriteGroup(target);
            } else {
                this.editFavoriteGroup(target);
            }
        },
        addFavoriteGroup(target) {
                const formData = new FormData(target);
                const { ['params-example-data']: { action } } = this.addGroup;
                if ( formData.get('changeBase') === 'on') {
                    formData.append('changeBase', 'Y');
                } else {
                    formData.append('changeBase', 'N');
                }
                formData.append('action', action);
                this.$store.dispatch('favourite/addGroupToFavorite', formData);
                this.closeBlock();
        },
        async editFavoriteGroup(target) {
            try{
                const formData = new FormData(target);
                const { ['params-example-data']: { action } } = this.changeGroup;
                if ( formData.get('changeBase') === 'on') {
                    formData.append('changeBase', 'Y');
                } else {
                    formData.append('changeBase', 'N');
                }
                formData.append('action', action);
                formData.append('groupId', this.groupId);
                this.$store.dispatch('favourite/editFavoriteGroup', formData);

                this.closeBlock();

                // if ( response.status === 200 ) {
                // }

            } catch(err) {
                console.error(err)
            }
        }
    },
    computed: {
        ...mapState({
            staticHiddenData: ({ favourite }) => favourite?.data?.routes.staticHiddenData,
            addGroup: ({favourite}) => favourite?.data?.routes?.addGroup,
            changeGroup: ({favourite}) => favourite?.data?.routes?.changeGroup,
            message: ({ favourite }) => favourite?.data?.message,
        })
    },
}
</script>

<style scoped lang="scss">
    .edit-favorite-item{
        &__form{
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            padding-bottom: 24px;
            @include point-md{
                padding: 24px 0;
            }
            @include point-lg{
                padding: 18px 0;
                flex-direction: row;
                align-items: center;
            }
        .def-input {
            margin: 0;
        }
            button{
                display: block;
                height: 48px;
                background: #618EAF;
                letter-spacing: 0.08em;
                text-transform: uppercase;
                font-weight: 500;
                font-size: 1rem;
                color: #fff;
                margin-right: 16px;
                padding: 0 48px;
                transition: .2s linear background;
                &:hover{
                    background: rgba(97, 142, 175, .8);
                    transition: .2s linear background;
                }
                @include point-lg{
                    order: 0;
                    margin-left: 8px;
                }
            }
        }
        &__form-group{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 12px 0;

            @include point-lg{
                width: 100%;

                margin: 0;
            }
            & > span{
                color: #618EAF;
                font-size: rem(12);
                line-height: 115%;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                border-bottom: rem(1) dashed #618EAF;
                cursor: pointer;
                margin-right: 15px;
            }

            label{
                font-weight: rem(16);
                font-weight: 500;
                display: flex;
                align-items: center;
                span{
                    white-space: pre;
                }
            }
            input{
                margin-right: 8px;
                margin-bottom: 5px;
            }

        }
        .def-input{
            width: 100%;
        }
    }
</style>